import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Riders from "@/pages/Riders";
import Businesses from "@/pages/Businesses";
import RentalShops from "@/pages/RentalShops";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Inbox from "@/pages/Inbox";
import Press from "@/pages/Press";
import Privacy from "@/pages/Privacy";
import Pricing from "@/pages/Pricing";

function SmoothScroll({ children }) {
  const lenisRef = useRef(null);
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <ScrollToTop />
        <div className="min-h-screen bg-[#F4F7F4] font-sans text-[#1A2521]">
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/riders" element={<Riders />} />
            <Route path="/businesses" element={<Businesses />} />
            <Route path="/partners" element={<RentalShops />} />
            <Route path="/rental-shops" element={<Navigate to="/partners" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/press" element={<Press />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/pricing" element={<Pricing />} />
          </Routes>
          <Footer />
          <Toaster richColors position="bottom-center" />
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
